var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("本日精選管理")]),_c('full-calendar',{ref:"calendar",attrs:{"events":_vm.fcEvents,"locale":"en"},on:{"dayClick":_vm.list_page,"changeMonth":_vm.changeMonth}}),_c('LoadingBlock',{attrs:{"active":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }